import React, { useEffect, useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import AppointmentTable from "../components/AppointmentTable";

import { Icon } from "@iconify/react/dist/iconify.js";
import { API_URL } from "..";
import { Link } from "react-router-dom";
import { Spinner } from "react-bootstrap";
const AppointmentPage = () => {
    const [data,setData]= useState([])
    const [loadingStatus,setLoadingStatus]= useState(false)
    const [counter,setCounter]= useState({
      newJobs: 0 ,
      activeJobs: 0,
      completedJobs: 0,
      declinedJobs: 0,
      unAssigned: 0
    })
    const fetchAppointments = async () => {
      setLoadingStatus(true)
         let headerList = {
           "Accept": "*/*"
        };
        const response = await fetch(
          API_URL+"/api/job/fetch/all",
          { method: "GET", headers: headerList }
        );
        const data = await response.json();
        setLoadingStatus(false)
        if (response.status === 200) {
          setData(data.job)


            const newJobs = data.job.filter(item => item.status === "new").length;
            const activeJobs = data.job.filter(item => item.status === "accepted" || item.status == 'In Transit' || item.status == 'In Progress'|| item.status === 'Arrived').length;
            const completedJobs = data.job.filter(item => item.status === "completed").length;
            const declinedJobs = data.job.filter(item => item.status === "declined").length;
            const unAssigned = data.job.filter(item => item.assigned_to == null && item.job_posted_by == 'customer' && item.job_posted_to == null).length;
            setCounter({
              newJobs: newJobs,
              activeJobs: activeJobs,
              completedJobs: completedJobs, 
              declinedJobs: declinedJobs,
              unAssigned:unAssigned
            })
        }
      };

      useEffect(()=>{
        fetchAppointments()
      },[1])
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Jobs" />
        <div className="mt-4 mb-20">
        <div className="col-xxl-12">
      <div className="row gy-4">
      <Link className="col-xxl-4 col-sm-6" to={'/jobs/total'}>
        <div>
          <div className="card p-3 shadow-2 radius-8 border input-form-light h-100 bg-gradient-end-1">
            <div className="card-body p-0">
              <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                <div className="d-flex align-items-center gap-2">
                  <span className="mb-0 w-48-px h-48-px bg-primary-600 flex-shrink-0 text-white d-flex justify-content-center align-items-center rounded-circle h6 mb-0">
                    <Icon icon="hugeicons:briefcase-01" className="icon" />
                  </span>
                  <div>
                    <span className="mb-2 fw-medium text-secondary-light text-sm">
                      Total Jobs
                    </span>
                    <h6 className="fw-semibold">{data.length || 0}</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        </Link>
        <Link className="col-xxl-4 col-sm-6" to={'/jobs/un-assigned'}>
        <div >
          <div className="card p-3 shadow-2 radius-8 border input-form-light h-100 bg-gradient-end-2">
            <div className="card-body p-0">
              <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                <div className="d-flex align-items-center gap-2">
                  <span className="mb-0 w-48-px h-48-px bg-success-main flex-shrink-0 text-white d-flex justify-content-center align-items-center rounded-circle h6">
                    <Icon icon="hugeicons:briefcase-01" className="icon" />
                  </span>
                  <div>
                    <span className="mb-2 fw-medium text-secondary-light text-sm">
                      UnAssigned Jobs
                    </span>
                    <h6 className="fw-semibold">{counter.unAssigned || 0}</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        </Link>
        <Link className="col-xxl-4 col-sm-6" to={'/jobs/new'}>
        <div >
          <div className="card p-3 shadow-2 radius-8 border input-form-light h-100 bg-gradient-end-2">
            <div className="card-body p-0">
              <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                <div className="d-flex align-items-center gap-2">
                  <span className="mb-0 w-48-px h-48-px bg-success-main flex-shrink-0 text-white d-flex justify-content-center align-items-center rounded-circle h6">
                    <Icon icon="hugeicons:briefcase-01" className="icon" />
                  </span>
                  <div>
                    <span className="mb-2 fw-medium text-secondary-light text-sm">
                      New Jobs
                    </span>
                    <h6 className="fw-semibold">{counter.newJobs || 0}</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        </Link>
        <Link className="col-xxl-4 col-sm-6" to={'/jobs/active'}>
        <div >
          <div className="card p-3 shadow-2 radius-8 border input-form-light h-100 bg-gradient-end-3">
            <div className="card-body p-0">
              <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                <div className="d-flex align-items-center gap-2">
                  <span className="mb-0 w-48-px h-48-px bg-yellow text-white flex-shrink-0 d-flex justify-content-center align-items-center rounded-circle h6">
                    <Icon icon="hugeicons:briefcase-01" className="icon" />
                  </span>
                  <div>
                    <span className="mb-2 fw-medium text-secondary-light text-sm">
                      Active Jobs
                    </span>
                    <h6 className="fw-semibold">{counter.activeJobs || 0}</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        </Link>
        <Link className="col-xxl-4 col-sm-6" to={'/jobs/completed'}>
         <div >
          <div className="card p-3 shadow-2 radius-8 border input-form-light h-100 bg-gradient-end-4">
            <div className="card-body p-0">
              <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                <div className="d-flex align-items-center gap-2">
                  <span className="mb-0 w-48-px h-48-px bg-purple text-white flex-shrink-0 d-flex justify-content-center align-items-center rounded-circle h6">
                    <Icon icon="hugeicons:briefcase-01" className="icon" />
                  </span>
                  <div>
                    <span className="mb-2 fw-medium text-secondary-light text-sm">
                      Completed Jobs
                    </span>
                    <h6 className="fw-semibold">{counter.completedJobs || 0}</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        </Link>
        <Link className="col-xxl-4 col-sm-6" to={'/jobs/declined'}>
        <div >
          <div className="card p-3 shadow-2 radius-8 border input-form-light h-100 bg-gradient-end-5">
            <div className="card-body p-0">
              <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                <div className="d-flex align-items-center gap-2">
                  <span className="mb-0 w-48-px h-48-px bg-pink text-white flex-shrink-0 d-flex justify-content-center align-items-center rounded-circle h6">
                    <Icon icon="hugeicons:briefcase-01" className="icon" />
                  </span>
                  <div>
                    <span className="mb-2 fw-medium text-secondary-light text-sm">
                      Declined Jobs
                    </span>
                    <h6 className="fw-semibold">{counter.declinedJobs || 0}</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        </Link>
     
      </div>
    </div>

        </div>
        {/* TableDataLayer */}
        {
           loadingStatus === true ?
            <div className="text-center mt-4">
              <Spinner/>
              </div> 
            : null 
        }
        
        {
           data.length === 0 && loadingStatus === false ?
            <div className="text-center mt-4">
              <p>No job data found....</p>
              </div> 
            : null 
        }
        
        {
            data.length == 0 ? null  : 
            <AppointmentTable data={data} />
        }

      </MasterLayout>

    </>
  );
};

export default AppointmentPage; 
